(() => {
  function init() {
    const nav = document.querySelector('.sp-collection__nav');
    if (!nav || nav.dataset.spReady) return;
    nav.dataset.spReady = 'true';
    const showCurrent = () => { nav.scrollLeft = nav.scrollWidth; };
    showCurrent();
    if ('ResizeObserver' in window) new ResizeObserver(showCurrent).observe(nav);
    if (document.fonts?.ready) document.fonts.ready.then(showCurrent);
    window.addEventListener('resize', showCurrent, {passive: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
